import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import { hideError } from '../actions/LayoutActions';
import { RouteComponentProps } from 'react-router';
import { updateUserAutheticatedInfo, refreshTokenAsyncThunk } from '../../Auth/actions/AuthActions';
import MasterLayout from '../components/MasterLayout';
import { ReactNode } from 'react';


const mapStateToProps = (state: RootState) => ({
    orderSheets: state.orderSheetsRdc.orderSheets,
    orderSheetsBusy: state.orderSheetsRdc.isBusy,
    showError: state.layoutRdc.showError,
    errorMessage: state.layoutRdc.errorMessage,
    
    signUpBusy: state.authRdc.signUpBusy,
    isAuthenticated: state.authRdc.isAuthenticated,
    checkTokenBusy: state.authRdc.refreshTokenBusy
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        hideError: () => {
            dispatch(hideError())
        },
        onFirebaseAuthChange: (isAutheticated: boolean) => {
            if (isAutheticated)//We are calling the getIdTokenResult to get the custom claims data.
                dispatch(refreshTokenAsyncThunk())
            else//Change the isAuthenticated state and let MasterLayout logic handle it properly.
                dispatch(updateUserAutheticatedInfo(false))
        }
    })
}

export type MasterLayoutProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any> & {children: ReactNode}

const MasterLayoutCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(MasterLayout);

export default MasterLayoutCnn